/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomerVendorAccountDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CustomerVendorAccountDto, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type WithVendorCodeItemRequestBuilder, WithVendorCodeItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/customers/{customerNumber}/vendors
 */
export interface VendorsRequestBuilder extends BaseRequestBuilder<VendorsRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.customers.item.vendors.item collection
     * @param vendorCode The vendor's code, in any casing.
     * @returns {WithVendorCodeItemRequestBuilder}
     */
     byVendorCode(vendorCode: string) : WithVendorCodeItemRequestBuilder;
    /**
     * Returns the customer's accounts across the agency's vendors, by vendor, in one list — a customer has at most one per line, so there is no paging. Removed accounts are left out. A customer with no accounts yet is a success with an empty list; the 404 means the customer itself is unknown. Admins and sales reps of an agency organization may read accounts.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CustomerVendorAccountDto[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<VendorsRequestBuilderGetQueryParameters> | undefined) : Promise<CustomerVendorAccountDto[] | undefined>;
    /**
     * Returns the customer's accounts across the agency's vendors, by vendor, in one list — a customer has at most one per line, so there is no paging. Removed accounts are left out. A customer with no accounts yet is a success with an empty list; the 404 means the customer itself is unknown. Admins and sales reps of an agency organization may read accounts.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<VendorsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns the customer's accounts across the agency's vendors, by vendor, in one list — a customer has at most one per line, so there is no paging. Removed accounts are left out. A customer with no accounts yet is a success with an empty list; the 404 means the customer itself is unknown. Admins and sales reps of an agency organization may read accounts.
 */
export interface VendorsRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const VendorsRequestBuilderUriTemplate = "{+baseurl}/api/customers/{customerNumber}/vendors{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const VendorsRequestBuilderNavigationMetadata: Record<Exclude<keyof VendorsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byVendorCode: {
        requestsMetadata: WithVendorCodeItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["vendorCode"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const VendorsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: VendorsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCustomerVendorAccountDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
